module.exports = __webpack_public_path__ + "gwen-6a9dbed9e22e4b53379b307f0dcb07f3.bundle.jpg";